import React, {Component} from 'react'
import Link from 'gatsby-link'

const menues = [
  ['about', '/about'],
  ['product', '/product'],
  ['member', '/member'],
  ['company', '/company'],
  ['news', '/news'],
  ['contact', '/contact']
]

class Menu extends Component {
  constructor () {
    super()
    this.state = {
      isHover: false,
      isMobile: false
    }
  }

  onHover () {
    this.setState({
      isHover: true
    })
  }

  onBlur () {
    this.setState({
      isHover: false
    })
  }

  componentDidMount() {
    if (window.innerWidth < 768) {
      this.setState({
        isMobile: true
      })
    }
  }

  render () {
    const {isActive, menu} = this.props
    if (this.state.isMobile) {
      return (
        <li>
          <Link to={menu[1]}>
            {menu[0].toUpperCase()}
          </Link>
        </li>
      )
    }
    if (isActive) {
      return (
        <li>
          <span className="menu-active">{menu[0][0].toUpperCase()}</span>
        </li>
      )
    } else if (this.state.isHover) {
      return (
        <li>
          <Link to={menu[1]}>
            <span onMouseOut={this.onBlur.bind(this)}>
              {menu[0].toUpperCase()}
            </span>
          </Link>
        </li>
      )
    } else {
      return (
        <li>
          <Link to={menu[1]}>
            <span
              onMouseOver={this.onHover.bind(this)}
              onMouseOut={this.onBlur.bind(this)}
            >{menu[0][0].toUpperCase()}</span>
          </Link>
        </li>
      )
    }
  }
}

export default ({current}) => (
  <ul id="menu">
    {
      menues.map(menu => <Menu isActive={current === menu[0]} menu={menu} key={menu[0]} />)
    }
  </ul>
)



// WEBPACK FOOTER //
// ./src/components/Menu.js